/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type FC } from 'react';

import { I18n } from '@coze-arch/i18n';

import styles from './index.module.less';

export interface PublishSuccessPanelProps {
  accessUrl: string;
  onCopy: () => void;
  onGoStore: () => void;
  onBack: () => void;
}

export const PublishSuccessPanel: FC<PublishSuccessPanelProps> = ({
  accessUrl,
  onCopy,
  onGoStore,
  onBack,
}) => (
  <div className={styles.card}>
    <div className={styles.success}>
      <div className={styles.successIcon}>✓</div>
      <h3>{I18n.t('abr_app_publish_success')}</h3>
      <p>{I18n.t('abr_app_publish_success_desc')}</p>
      <div className={styles.urlBox}>
        <div className={styles.urlLabel}>{I18n.t('abr_app_access_url')}</div>
        <div className={styles.urlRow}>
          <div className={styles.urlText}>{accessUrl}</div>
          <button type="button" className={styles.btnCopy} onClick={onCopy}>
            {I18n.t('abr_app_copy_link')}
          </button>
        </div>
      </div>
      <div className={styles.actions}>
        <button type="button" className={styles.btnPrimary} onClick={onGoStore}>
          {I18n.t('abr_app_go_store')}
        </button>
        <button type="button" className={styles.btnGhost} onClick={onBack}>
          {I18n.t('abr_app_back_ide')}
        </button>
      </div>
    </div>
  </div>
);
